import { Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ADMIN_SHELL_ICON_BUTTON_CLASS } from './adminShellChrome.styles.js';

export interface AdminSettingsButtonProps {
  readonly open: boolean;
  readonly onOpen: () => void;
  readonly className?: string;
}

/** Icon-only Settings gear — opens AdminSettingsSheet. */
export function AdminSettingsButton({
  open,
  onOpen,
  className,
}: AdminSettingsButtonProps): JSX.Element {
  const { t } = useTranslation('admin');
  const ariaLabel = t('chrome.settings.openAria');

  return (
    <button
      type="button"
      className={[ADMIN_SHELL_ICON_BUTTON_CLASS, className].filter(Boolean).join(' ')}
      aria-label={ariaLabel}
      aria-expanded={open}
      aria-haspopup="dialog"
      title={ariaLabel}
      data-testid="admin-shell-settings"
      onClick={onOpen}
    >
      <Settings className="h-5 w-5 stroke-[1.75]" aria-hidden />
    </button>
  );
}
